/*
'Irish Geography'. '
Irish Geography is a multi-disciplinary journal that publishes a range of full and short articles,
commentaries and reviews on or about Ireland's geographies.
Articles take a number of forms and all submissions are welcome.
Longer articles would document substantial pieces of original research across a range of geographical areas and subjects.
Shorter submissions, which might include short empirical pieces, theoretical commentaries,
subject reviews and other types of commentary, would also be welcome.
Special Issues are also encouraged on specific topics from human, physical and environmental geographies.
The journal also publishes Book Reviews of recent work published in Ireland and beyond.'

*/
import { Section } from "./data-types";

export const Journal: {
	sections: (Section | (() => JSX.Element))[];
} = {
	sections: [
		{
			type: "cards",
			options: {
				columns: 2,
			},
			items: [
				{
					type: "CardItem",
					options: {
						// span: "max"
					},
					data: {
						title: "Irish Geography",
						content: () => [
							<p>
								Irish Geography is a multi-disciplinary journal that publishes a range of full and short articles,
								commentaries and reviews on or about Ireland's geographies.
								Articles take a number of forms and all submissions are welcome.
							</p>,
							<p>
								Longer articles would document substantial pieces of original research across a range of geographical areas and subjects.
								Shorter submissions, which might include short empirical pieces, theoretical commentaries,
								subject reviews and other types of commentary, would also be welcome.
							</p>,
							<p>
								Special Issues are also encouraged on specific topics from human, physical and environmental geographies.
								The journal also publishes Book Reviews of recent work published in Ireland and beyond.
							</p>,
							<p>
								<a href="https://irishgeography.ie/">Visit the Irish Geography</a>
							</p>
						]
					},
				},
				{
					type: "CardImage",
					options: {
					},
					data: {
						media: {
							type: "image",
							src: "/images/examples/5.jpg"
						},
					},
				}
			]
		}
	]
}
